<template>
    <b-container fluid class="content-box-white">
        <b-container id="partner-list">
            <b-row class="content-section text-center">
                <b-col cols="12" class="content-area text-center" v-animate-onscroll="'animated zoomIn'">
                    <h2 :id="'header-section-footer'" v-html="$store.state.labels.LABEL_TITLE_PARTNER"></h2>
                    <b-row class="text-center">
                        <b-col cols="4" v-for="partner in partnerList" v-bind:key="partner.partner_id" v-animate-onscroll="'animated zoomIn'">
                            <div class="partner-logo">
                                <a rel="noopener" :href="partner.partner_url" target="_blank"><b-img-lazy
                                        v-bind="partnercontentProps" :src="partner.partner_logo" :alt="partner.partner_name"
                                        class="img-center"></b-img-lazy></a>
                                </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
export default {
    name: 'ContentBoxWhiteFooter',
    props: {
        partners: { type: Array, required: true, default: null },
    },
    data() {
        return {
            partnercontentProps: {
                center: true,
                fluidGrow: false,
                blank: true,
                width: 200,
                blankColor: "#bbb",
                class: "p-20",
            },
        }
    },
    computed: {
        partnerList() {
            return this.partners
        }
    },
}
</script>
<style>
.partner-logo {
    display: flex;
  justify-content: center;
}
.partner-logo img {
  max-height: 180px;
}
</style>

